import React from 'react';

export default function Terms() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <span style={styles.logo}><span style={{color:'#fff'}}>Family</span><span style={{color:'#D4A017'}}>Bandhan</span></span>
        </div>
        <h1 style={styles.title}>Terms of Use</h1>
        <p style={styles.meta}>Effective date: 19 July 2026 · LBLOGIC Solutions (OPC) Private Limited</p>

        <Section title="1. Acceptance">
          By accessing or using FamilyBandhan at familybandhan.in, or by downloading and using the FamilyBandhan Desktop application, you agree to these Terms. If you do not agree, please do not use the platform. You must be at least 18 years old to create a web account. FamilyBandhan Desktop has no account, no purchase, and no age-verification step of its own — it is intended for general family use.
        </Section>

        <Section title="2. What FamilyBandhan Is">
          FamilyBandhan is a private family tree and legacy preservation platform. It allows families to build multigenerational trees, record member stories, upload photos, and preserve family history across generations. FamilyBandhan is offered in two forms: the web platform at familybandhan.in, and FamilyBandhan Desktop, a free, standalone Windows application that stores all data locally on your device.
        </Section>

        <Section title="3. Your Account">
          Your web account is identified by your email address. You are responsible for all activity under your account. Do not share your OTP with anyone. Each email address creates one family tree. FamilyBandhan Desktop does not use an account, OTP login, or any activation key of any kind — it works immediately after installation, as described in Section 6A.
        </Section>

        <Section title="4. Acceptable Use">
          You agree to use FamilyBandhan only for lawful, family-appropriate purposes. You must not upload content that is offensive, defamatory, sexually explicit, or violates any applicable law. You must not attempt to access other users' family trees without permission. This applies equally to content you create within FamilyBandhan Desktop.
        </Section>

        <Section title="5. Your Content">
          You retain full ownership of all content you upload or create — photos, stories, and member information — whether on the web platform or within FamilyBandhan Desktop. By uploading content to the web platform, you grant FamilyBandhan a limited licence to store and display it solely for the purpose of providing the service to you. We do not use your family data for advertising or any commercial purpose. Content you create in FamilyBandhan Desktop remains solely on your device; we do not have access to it, as described in Section 6A.
        </Section>

        <Section title="6. Premium Subscription (Web Platform)">
          Family Premium on the web platform is available at ₹99 per year per family. Payment is processed securely via Razorpay. Premium unlocks Family Gallery and Family Traditions modules. Please refer to our Refund Policy for cancellation terms.
        </Section>

        <Section title="6A. FamilyBandhan Desktop — Free to Use">
          FamilyBandhan Desktop is completely free, with no purchase, subscription, or activation key of any kind. Simply download and install the application to use it — every feature is unlocked from the first launch, for as long as you use it. The application does not connect to any server, collect any personal data, or require an internet connection at any point. Since there is no payment involved, no refund provisions apply to FamilyBandhan Desktop.
        </Section>

        <Section title="7. Intellectual Property">
          The FamilyBandhan name, logo, design, code, and the .fmly file format are the intellectual property of LBLOGIC Solutions (OPC) Private Limited. You may not copy, reproduce, reverse-engineer, or distribute any part of the web platform or FamilyBandhan Desktop application without written permission.
        </Section>

        <Section title="8. Limitation of Liability">
          FamilyBandhan and FamilyBandhan Desktop are provided as-is. We are not liable for any loss of data, indirect damages, or consequential loss arising from your use of either product. Since FamilyBandhan Desktop stores all data locally on your device with no cloud backup, we strongly recommend keeping your own backups of your .fmly file. We similarly recommend web platform users keep personal backups of important family content.
        </Section>

        <Section title="9. Governing Law">
          These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Bengaluru, Karnataka.
        </Section>

        <Section title="10. Contact">
          For any questions regarding these Terms, whether about the web platform or FamilyBandhan Desktop, write to us at support@familybandhan.in.
        </Section>

        <div style={styles.footer}>
          <a href="/" style={styles.link}>← Back to FamilyBandhan</a>
          <span style={styles.sep}>·</span>
          <a href="/privacy" style={styles.link}>Privacy Policy</a>
          <span style={styles.sep}>·</span>
          <a href="/refund" style={styles.link}>Refund Policy</a>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '24px' }}>
      <h2 style={{ fontSize: '15px', color: '#1a0533', marginBottom: '6px' }}>{title}</h2>
      <p style={{ fontSize: '14px', color: '#4B5563', lineHeight: 1.7, margin: 0 }}>{children}</p>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', background: '#f8f7ff',
    padding: '32px 16px', fontFamily: "'DM Sans', Arial, sans-serif",
  },
  card: {
    maxWidth: '720px', margin: '0 auto',
    background: '#ffffff', borderRadius: '16px',
    padding: '40px 36px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
  },
  header: {
    marginBottom: '24px',
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: '22px', background: '#0e0018',
    padding: '10px 20px', borderRadius: '8px',
    display: 'inline-block',
  },
  logo: { letterSpacing: '0.5px' },
  title: { fontSize: '26px', color: '#1a0533', marginBottom: '4px' },
  meta: { fontSize: '12px', color: '#9CA3AF', marginBottom: '32px' },
  footer: {
    marginTop: '40px', paddingTop: '20px',
    borderTop: '1px solid #E5E7EB',
    display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center',
  },
  link: { fontSize: '13px', color: '#7C3AED', textDecoration: 'none' },
  sep: { color: '#D1D5DB', fontSize: '13px' },
};